import SFAPI from "api/sfapi";


//constants
const SF_API_VERSION = 'v57.0';

/**
 * handles schema generation
 */
export class  CQFSchemaBuilder  {
    sfdcSessionId : string = '';
    readOnlyFields : string[] = [];
    fieldsForUISchema : string[] = [];
    mapFieldAPIName : Map<string, any> = new Map<string, any>();
    mapFieldUIType : Map<string, any> = new Map<string, any>();

    /**
     * method to get objects from schema object tree
     */
    getObject(schemaObj: any, objects: any[]){
        objects.push(schemaObj.objectType);
        if(schemaObj.child && Object.keys(schemaObj.child).length){
            if(!Array.isArray(schemaObj.child)){
                this.getObject(schemaObj.child, objects);
            }else{
                schemaObj.child.forEach((object) => {
                    this.getObject(object, objects);
                })
            }

        }
    }

    /**
     * method to get object to fields and child object map
     */
    getObjectToFieldsMap(schemaObj: any, objToFields : Map<any, any>){
        let newObj : any = {};
        newObj.fields = schemaObj.fields;
        // handle context property for sobjectschema
        if(schemaObj.context && Object.keys(schemaObj.context).length) {
            newObj.context = schemaObj.context;
        }
        if(schemaObj.child && Object.keys(schemaObj.child).length){
            if(!Array.isArray(schemaObj.child)){
            //sets child attribute when object contains child
                newObj.child = { "childObj" : schemaObj.child.objectType,
                "relationshipName": schemaObj.child.relationshipName };
                this.getObjectToFieldsMap(schemaObj.child, objToFields);
            }else{
                schemaObj.child.forEach((object) => {
                    if(object && object.hasOwnProperty('child')){
                        newObj.child = { "childObj" : object.child.objectType,
                        "relationshipName": object.child.relationshipName };
                    }
                    this.getObjectToFieldsMap(object, objToFields);
                })
            }
        }
        //set object
        objToFields.set(schemaObj.objectType, newObj);
    }

    /**
     * method to convert objects results to the required object properties
     * objToProperties sample :  '{"cqext__SQX_Safety_Inspection__c":{"preventAddition":true,"preventDeletion":true,"title":"Safety Inspection","type":"object","properties":{"cqext__SQX_Safety_Inspection_Criteria__r":{"type":"array","items":{"$ref":"#/definitions/cqext__SQX_Safety_Inspection_Criteria__c"}},"cqext__Assignee_Type__c":{"title":"Assignee Type","type":"string","oneOf":[{"title":"User","const":"User"},{"title":"Queue","const":"Queue"}]},"cqext__End_Date__c":{"title":"End Date","type":"string","format":"date-time"},"cqext__Inspection_Title__c":{"title":"Inspection Title","type":"string","maxLength":255},"cqext__Inspection_Type__c":{"title":"Inspection Type","type":"string","oneOf":[{"title":"Equipment","const":"Equipment"},{"title":"Onsite Work Inspection","const":"Onsite Work Inspection"}]},"cqext__SQX_Assignee__c":{"title":"Assignee","type":"string"},"cqext__SQX_Checklist__c":{"title":"Checklist","type":"string"},"cqext__SQX_Location__c":{"title":"Location","type":"string"},"cqext__Start_Date__c":{"title":"Start Date","type":"string","format":"date-time"}},"required":["cqext__End_Date__c","cqext__Inspection_Title__c","cqext__Start_Date__c"]},"cqext__SQX_Safety_Inspection_Criteria__c":{"preventAddition":true,"preventDeletion":true,"title":"Safety Inspection Criteria","type":"object","properties":{"cqext__SQX_Safety_Checklist__r":{"type":"array","items":{"$ref":"#/definitions/cqext__SQX_Safety_Checklist__c"}},"cqext__Criteria_Title__c":{"title":"Criteria Title","type":"string","maxLength":32768}},"required":[]},"cqext__SQX_Safety_Checklist__c":{"preventAddition":true,"preventDeletion":true,"title":"Safety Checklist","type":"object","properties":{"cqext__Response_Type__c":{"title":"Response Type","type":"string"},"cqext__Response_value__c":{"title":"Response value","type":"string","maxLength":255},"cqext__Response_score__c":{"title":"Response score","type":"integer"}},"required":[]}}'
     */
    async convertToProperties (objects: any[], objectToFields: any, results: any){
        var objToProperties = {};
        let dependentFieldsInfo : any = {};
        let objPromises = objects.map(async (obj) => {
            var objFields = objectToFields.get(obj);
            var objProperty : any = {"preventAddition": true, "preventDeletion": true};
            var objDescribe = results.get(obj);
            objProperty.title = objDescribe.label;
            objProperty.type = "object";
            objProperty.properties = {};
            objProperty.required = [];
            if(objFields){
                if(objFields.child){
                    objProperty.properties[objFields.child.relationshipName] =  { "type":"array",
                                                                                "items":{"$ref": "#/definitions/" + objFields.child.childObj} };
                }
                // added a condition to render field properly for context object
                if(objFields.context) {
                    objProperty.properties[objFields.context.relationshipName] = {type:"object", "$ref": "#/definitions/" + objFields.context.contextObj};
                }
                if(objFields.fields){
                    let promises = objFields.fields.map(async (objField : any)=>{
                        for(let field in objDescribe.fields) {
                        	this.mapFieldAPIName.set(field.toLowerCase(), field);
                    	}
                        var fieldAPIName = this.mapFieldAPIName.get(objField);
                        let result =  await this.getFieldValues(objDescribe, fieldAPIName);
                        if(result.hasOwnProperty('controllerFieldInfo')){
                            if(result.controllerFieldInfo.hasOwnProperty('controllerName')){
                                dependentFieldsInfo = {...dependentFieldsInfo,  [fieldAPIName] : result };
                            }
                        }
                        objProperty.properties[fieldAPIName] = result;
                    	this.uiTypeMappingWithFieldType(objDescribe, fieldAPIName, objField);
                        if(objDescribe.fields[fieldAPIName].required){
                            objProperty.required.push(fieldAPIName);
                        }
                    });
                    await Promise.all(promises);
                }
            }
            if(Object.keys(dependentFieldsInfo).length){
                let fields = Object.keys(dependentFieldsInfo);
                fields.forEach((field) => {
                    if(dependentFieldsInfo[field].hasOwnProperty('controllerFieldInfo')){
                        let controllerName = dependentFieldsInfo[field].controllerFieldInfo.controllerName;
                         objProperty.properties[controllerName]['validFor'] = dependentFieldsInfo[field].controllerFieldInfo.validFor;
                        objProperty.properties[controllerName]['child'] = objDescribe.apiName + '.' + field;  //added for refreshing child record data based on parent data
                        objProperty.properties[field]['dependent'] =  dependentFieldsInfo[field].controllerFieldInfo.controllerName;
                        delete objProperty.properties[field].controllerFieldInfo;
                    }
                })
            }
            objToProperties[obj] = objProperty;
        });

        await Promise.all(objPromises);
        return objToProperties;
    }

    /**
     * method to convert shemaObjtree to schema
     * schema sample: '{"requiresSignature":false,"type":"object","properties":{"cqext__SQX_Safety_Inspection__c":{"preventAddition":true,"preventDeletion":true,"title":"Safety Inspection","type":"object","properties":{"cqext__SQX_Safety_Inspection_Criteria__r":{"type":"array","items":{"$ref":"#/definitions/cqext__SQX_Safety_Inspection_Criteria__c"}},"cqext__Assignee_Type__c":{"title":"Assignee Type","type":"string","oneOf":[{"title":"User","const":"User"},{"title":"Queue","const":"Queue"}]},"cqext__End_Date__c":{"title":"End Date","type":"string","format":"date-time"},"cqext__Inspection_Title__c":{"title":"Inspection Title","type":"string","maxLength":255},"cqext__Inspection_Type__c":{"title":"Inspection Type","type":"string","oneOf":[{"title":"Equipment","const":"Equipment"},{"title":"Onsite Work Inspection","const":"Onsite Work Inspection"}]},"cqext__SQX_Assignee__c":{"title":"Assignee","type":"string"},"cqext__SQX_Checklist__c":{"title":"Checklist","type":"string"},"cqext__SQX_Location__c":{"title":"Location","type":"string"},"cqext__Start_Date__c":{"title":"Start Date","type":"string","format":"date-time"}},"required":["cqext__End_Date__c","cqext__Inspection_Title__c","cqext__Start_Date__c"]}},"definitions":{"cqext__SQX_Safety_Inspection_Criteria__c":{"properties":{"cqext__SQX_Safety_Inspection_Criteria__c":{"preventAddition":true,"preventDeletion":true,"title":"Safety Inspection Criteria","type":"object","properties":{"cqext__SQX_Safety_Checklist__r":{"type":"array","items":{"$ref":"#/definitions/cqext__SQX_Safety_Checklist__c"}},"cqext__Criteria_Title__c":{"title":"Criteria Title","type":"string","maxLength":32768}},"required":[]}},"type":"object"},"cqext__SQX_Safety_Checklist__c":{"properties":{"cqext__SQX_Safety_Checklist__c":{"preventAddition":true,"preventDeletion":true,"title":"Safety Checklist","type":"object","properties":{"cqext__Response_Type__c":{"title":"Response Type","type":"string"},"cqext__Response_value__c":{"title":"Response value","type":"string","maxLength":255},"cqext__Response_score__c":{"title":"Response score","type":"integer"}},"required":[]}},"type":"object"}}}'
     */
    async convertToSchema(objects: any[], schemaObj: any, results: any){

        var objectToFields = new Map();
        this.getObjectToFieldsMap(schemaObj, objectToFields);

        var objProperties = await this.convertToProperties(objects, objectToFields, results);

        var schema : any = {};
        schema.requiresSignature = false;
        schema.type = "object";
        schema.properties = {};
        schema.definitions = {};
        objects.forEach((obj,i)=>{
            if(i === 0){
                schema.properties[obj] =  objProperties[obj];
            }else{
                var tempSchema = {"properties": {} , "type": "object"};
                tempSchema.properties[obj] = objProperties[obj];
                schema.definitions[obj] =  tempSchema;
            }
        });

        return schema;
    }

    /**
     * Method to describe field for schema
     */
    async getFieldValues(objDescribe: any, objField: any){
        let fieldDescribe = objDescribe.fields[objField];
        let fieldObj : any = {};
        fieldDescribe.label = fieldDescribe.label.includes('&amp;') ? fieldDescribe.label.replace('&amp;', '&') : fieldDescribe.label;
        fieldObj.title = fieldDescribe.label;
        let dataType = fieldDescribe.dataType;
        //checks data type and sets fieldObj
        if(dataType === "TextArea" || dataType === "String" || dataType === "Url" ){
            fieldObj.type = "string";
            fieldObj.maxLength = fieldDescribe.length;
            fieldObj.regexRuleName = '';
            fieldObj.pattern = '';
            fieldObj.errorMessage = '';
            fieldObj.default = '';
        }else if(dataType === "Phone"){
            fieldObj.type = "integer";
            fieldObj.maxLength = fieldDescribe.length;
            fieldObj.regexRuleName = '';
            fieldObj.pattern = '';
            fieldObj.errorMessage = '';
            fieldObj.default = '';
        }else if(dataType === "Double" || dataType === "Number"  || dataType === "Int" ){
            fieldObj.type = "number";
            fieldObj.regexRuleName = '';
            fieldObj.pattern = '';
            fieldObj.errorMessage = '';
            fieldObj.default = '';
        }else if(dataType === "Date"){
            fieldObj.type = "string";
            fieldObj.format = "date";
            fieldObj.default = '';
        }else if(dataType === "DateTime"){
            fieldObj.type = "string";
            fieldObj.format = "date-time";
            fieldObj.default = '';
        }else if(dataType === "Picklist"){
            fieldObj.type = "string";
            //get recordtypeId
            let recordTypeId = Object.keys(objDescribe.recordTypeInfos)[0];
            await this.getPicklistValues(objDescribe.apiName, recordTypeId, fieldDescribe.apiName, fieldObj, fieldDescribe.controllerName );
        }else if(dataType === "Reference"){
            fieldObj.type = "string";
            fieldObj.lookupTo = objDescribe.fields[objField].referenceToInfos[0].apiName;
        }else if(dataType === "Boolean"){
            fieldObj.type = "boolean";
        }else if(dataType === "MultiPicklist"){
            fieldObj.type = "string";
        }else if(dataType === "Email"){
            fieldObj.type = "string";
            fieldObj.format = "email";
            fieldObj.regexRuleName = '';
            fieldObj.pattern = '';
            fieldObj.errorMessage = '';
            fieldObj.default = '';
        } else if(dataType === 'Time') {
            fieldObj.type = "string";
            fieldObj.format = "time";
            fieldObj.regexRuleName = '';
            fieldObj.pattern = '';
            fieldObj.errorMessage = '';
            fieldObj.default = '';
        }else{
            fieldObj.type = "string";
            fieldObj.regexRuleName = '';
            fieldObj.pattern = '';
            fieldObj.errorMessage = '';
            fieldObj.default = '';
        }
        return fieldObj;
    }

    /**
	 * This method maps uitype using field type for uischema
	 */
	uiTypeMappingWithFieldType(obj: any, field: any, apiName: any){
        let fieldDescribe = obj.fields[field];
        let readOnlySchema = { "effect" : "DISABLE", "condition" : { "scope": "#", "schema" : {} } }
        let uiDefinition = { "type" : "", "scope" : "", "options" : {}};
        let dataType = fieldDescribe.dataType;

        if(this.readOnlyFields.includes(apiName)){
            uiDefinition["rule"] = readOnlySchema;
        }

        //checks data type and set uischema
        if(dataType === "Reference"){
            uiDefinition["type"] = "lookup";
            uiDefinition["lookupTo"] = fieldDescribe.referenceToInfos[0].apiName;
        }else if(dataType !== "Picklist"){
            uiDefinition["type"] = "Control";
        }else{
            uiDefinition["type"] = "select";
            uiDefinition["options"]["showLabel"] = true;
        }
        this.mapFieldUIType.set(field, uiDefinition);
	}

    /**
     * Method to retrieve picklist values for field
     */
    async getPicklistValues(objectApiName : any, recordTypeId: any,  fieldApiName: any, fieldObj: any, controllerName: any){
        //Get a reference to jQuery that we can work with
        let instanceUrl = localStorage.getItem('instanceurl');
        var weblink = instanceUrl + '/services/data/'+SF_API_VERSION+'/ui-api/object-info/' + objectApiName + '/picklist-values/' + recordTypeId + '/' + fieldApiName;
        var SESSION_ID = await new SFAPI().getAccessToken();

        let response = await fetch(weblink,
                {
                    method: 'GET', //Type POST or GET
                    headers: {
                        'Authorization' : 'OAuth ' + SESSION_ID,
                        'ContentType': 'application/json'
                    }
                });

      
        let result: any = response.json();
        
        //Response will be stored in result variable in the form of Object.
        result.then((res : any) => {
            if(controllerName){
                // storing controller field info along with the picklist values, and use them while building the schema.
                fieldObj['controllerFieldInfo'] = {};
                let obj :any = {
                    'controllerName' : controllerName,
                    'validFor':{}
                }

                Object.keys(res.controllerValues).forEach((controlKey) => {
                    obj.validFor[''+controlKey] = [];
                });
                
                res.values.forEach((value) => {
                    for(let i=0; i<value.validFor.length; i++){
                        let validForIndex : number = value.validFor[i];
                        let controllingKey : string = String(Object.keys(res.controllerValues).find(key => res.controllerValues[key] === validForIndex));
                        obj.validFor[''+controllingKey].push({"title": value.label, "const": value.value});
                    }
                });
                fieldObj['controllerFieldInfo'] = obj;
            }else{
                if(!Object.keys(fieldObj).includes('oneOf')){
                    fieldObj.oneOf = [];
                }
                res.values.forEach((value) => {
                    fieldObj.oneOf.push({"title": value.label, "const": value.value});
                });
            }
        })
        

        return result;
    }

    /**
     * This method generates ui schema
     * @returns : UI schema
     */
    uischema(){
        var property = '';
        var elements : any = {
            "elements": [],
                "label": "Safety Inspection",
                "type": "Group"
        };
        let verticalSchema : any = {"elements":[],"type": "VerticalLayout"};
        let temp : any = { elements: [],'type': 'HorizontalLayout'};
        this.fieldsForUISchema.forEach((item) => {
            property = this.mapFieldAPIName.get(item);
            let nextRow = false;
            let fieldUISchema = this.mapFieldUIType.get(property);
            let scope = '#/properties/cqext__SQX_Safety_Inspection__c/properties/'+property;
			fieldUISchema["scope"] = scope;
            if( this.fieldsForUISchema.length > 2){
            	if(temp.elements.length < 2 ){
					temp.elements.push(fieldUISchema);
        		}else{
            		verticalSchema.elements.push(temp);
            		temp = { elements: [],'type': 'HorizontalLayout'};
                    nextRow = true;
       			}
                if(nextRow){
            		temp.elements.push(fieldUISchema);
            		nextRow = false;
        		}
        		if(this.fieldsForUISchema.indexOf(item) === this.fieldsForUISchema.length - 1){
            		verticalSchema.elements.push(temp);
        		}
        	}else{
                if(this.fieldsForUISchema.indexOf(item) === this.fieldsForUISchema.length - 1){
                    temp.elements.push(fieldUISchema);
                    verticalSchema.elements.push(temp);
                }else{
                   	temp.elements.push(fieldUISchema);
                }
        	}
        })
        elements.elements.push(verticalSchema);

        return elements;
    }

    /**
    * method for ajax call for object and convert to schema
    */
    async apiCall (schemaObj: any, metadata: any, fields: any[]) {
        let sfdcSessionId = await new SFAPI().getAccessToken();
        let objects = [];
        this.readOnlyFields = fields;
        await this.getObject(schemaObj, objects);
        this.fieldsForUISchema = schemaObj.fields;

        let results = new Map();
        let requests = objects.map(async (obj, index) => {
            let instanceUrl = localStorage.getItem('instanceurl');
            let weblink = instanceUrl + '/services/data/'+SF_API_VERSION+'/ui-api/' + metadata + '/' + obj;

            let requestPromise = await fetch(weblink, {
                method: 'GET', //Type POST or GET
                headers: {
                    'Authorization' : 'OAuth ' + sfdcSessionId,
                    'ContentType': 'application/json'
                }
            });

            let result = await requestPromise.json();

            results.set(obj, result);
        })
        await Promise.all(requests);

        let schema = await this.convertToSchema(objects, schemaObj, results);
        let definitions: any = JSON.parse(JSON.stringify(schema.definitions));
        let definitionKeys: any = Object.keys(definitions);
        // in below loop, assigning the picklist values to the dependent picklist field in 'validFor' key.
        definitionKeys.forEach((key: string) => {
            let innertKeys : any = Object.keys(definitions[key]['properties'][key]['properties']);
            innertKeys.forEach((innerKey: string) => {
                let objProp : any = definitions[key]['properties'][key]['properties'][innerKey];
                if(typeof objProp == 'object' && definitions[key]['properties'][key]['properties'][innerKey]['controllerFieldInfo']){
                    let controllingFieldName : string = definitions[key]['properties'][key]['properties'][innerKey]['controllerFieldInfo']['controllerName'];
                    if(definitions[key]['properties'][key]['properties'][controllingFieldName]['oneOf']){
                        delete definitions[key]['properties'][key]['properties'][controllingFieldName]['oneOf'];
                    }
                    definitions[key]['properties'][key]['properties'][controllingFieldName]['validFor'] =  definitions[key]['properties'][key]['properties'][innerKey]['controllerFieldInfo']['validFor'];
                    delete definitions[key]['properties'][key]['properties'][innerKey]['controllerFieldInfo'];
                }
            })
        });
        schema.definitions = definitions;
        return schema;

    }

    /**
     * Get all objects in org.
     */
    async objectApiCall(){
        let sfdcSessionId = await new SFAPI().getAccessToken();
        let instanceUrl = localStorage.getItem('instanceurl');
        let weblink = instanceUrl + '/services/data/'+SF_API_VERSION+'/sobjects';

        let requestPromise = await fetch(weblink, {
            method: 'GET', //Type POST or GET
            headers: {
                'Authorization' : 'OAuth ' + sfdcSessionId,
                'ContentType': 'application/json'
            }
        });
        let result = await requestPromise.json();
        console.log(result);
        return result;
    }


}